// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__2eyd1","load6":"Loader_load6__2egzM","round":"Loader_round__3vBpL"};